import { connect } from "react-redux";
import { createInitialStateLoading } from "../../loading/createInitialStateLoading";
import { IdAssetBundleCore } from "../../loading/IdAssetBundleCore";
import { SceneLoading } from "../../loading/SceneLoading";
var initial = createInitialStateLoading(IdAssetBundleCore.Initial);
var mapState = function (state) { return ({
    bundles: [state.loading.bundles[IdAssetBundleCore.Initial] || initial],
}); };
export var BF2SceneLoadingInitial = connect(mapState)(SceneLoading);



//////////////////
// WEBPACK FOOTER
// ./src/features/scenes/scenes/BF2SceneLoadingInitial.tsx
// module id = 2230
// module chunks = 3